import { render, staticRenderFns } from "./HomeCourse.vue?vue&type=template&id=1407ec74&scoped=true"
import script from "./HomeCourse.vue?vue&type=script&lang=js"
export * from "./HomeCourse.vue?vue&type=script&lang=js"
import style0 from "./HomeCourse.vue?vue&type=style&index=0&id=1407ec74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1407ec74",
  null
  
)

export default component.exports